<template>
  <div>
    <div class="zn-template-head">
      <span class="zn-template-title">团队报销申请表填写要求</span>
    </div>
    <div class="zn-template-content" ref="tplContent">
      <img src="../../../assets/images/baoxiao.jpg" style="width:100%">
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: Object,
  },
}
</script>
